import { Component, HostBinding, Input } from '@angular/core';
import { Theme } from 'studio-components';

@Component({
  selector: 'studio-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss'],
})
export class ProgressSpinnerComponent {
  @HostBinding('class')
  @Input()
  public theme: Theme = 'light';
  @Input() public size = 24;
}
